// extracted by mini-css-extract-plugin
export var deleteModal = "_jv-0";